const routeNames = {
  HOME: "/",
  LOGIN: "/login",
  CREATE_NOTIFICATION: "/create-notification",
  MANAGE_USERS: "/manage-users",
  MENTORSHIP_USERS: "/mentorship-users",
  AI_CHATS: "/ai-chats",
  AI_CHATS_NEW: "/ai-chats/new",
  AI_CHAT_ID: "/ai-chats/:id",
  AI_CHATS_NEW_NONADMIN: "/hignome-chats/new",
  AI_CHATS_NONADMIN: "/hignome-chats",
  GRIT: "/grit",
  SETTINGS: "/settings",
  MENTORSHIP: "/mentorship",
  MENTORSHIP_ADD: "/mentorship/add",
  MENTORSHIP_DETAILS: "/mentorship/:programId",
  MENTORSHIP_EDIT: "/mentorship/:programId/edit",
  MENTORSHIP_RELATIONSHIP_ADD: "/mentorship/:programId/createrelationships"
};

export default routeNames;
